"use client";
import React from 'react';

interface AboutSectionProps {
  badge?: string;
  title?: string;
  description?: string;
}

export default function AboutSection({
  badge = "ABOUT US",
  title = "Overview",
  description = "Melco India Pvt. Ltd. has come to be known as a name of immense repute in the highly specialized domain of Ash Handling Systems and Coal Mill Reject Systems. Since its inception over three decades ago, the company has been a trusted supplier of equipment and systems for public sector boards and private sector power plants & NTPC, a leading power generating super supplier of electricity in India.",
}: AboutSectionProps) {
  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-8 bg-white">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12">
        
        {/* Left Box: Badge & Title */}
        <div className="flex-1 text-center md:text-right">
          <span className="text-[#ffa20d] font-bold text-sm tracking-wider uppercase block mb-1">
            {badge}
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1a1a1a] leading-tight whitespace-pre-line">
            {title}
          </h2>
        </div>

        {/* Vertical Divider */}
        <div className="hidden md:block w-[2px] h-28 bg-gray-200 shrink-0" />

        {/* Right Box: Overview Description */}
        <div className="flex-1 text-center md:text-left text-gray-600 text-sm sm:text-base leading-relaxed">
          <p>{description}</p>
        </div>

      </div>
    </section>
  );
}